var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Label2 } from "@irati/ui/src/Labels";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import ProfilePicture from "@irati/ui/src/ProfilePicture";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  text-align: left;\n"], ["\n  margin-bottom: 10px;\n  text-align: left;\n"])));
var WhoCreated = function (_a) {
    var createdBy = _a.createdBy, bold = _a.bold;
    return (React.createElement(Wrapper, null,
        React.createElement(ProfilePicture, { user: createdBy, marginRight: true, small: true }),
        React.createElement(Label2, { bold: bold }, firstnameLastname(createdBy))));
};
export default WhoCreated;
var templateObject_1;
